<div class="app-container" [class.show-spinner]="showLoadingSpinner()">
  @if (headerItems && !isFullPageRoute()) {
    <lib-header
      [adminUrl]="adminUrl"
      [headerItems]="headerItems"
      [isProvider]="true"
      [isAdmin]="true"
      [unreadMessageCount]="unreadMessageCount"
      (entraLogout)="systemService.logout()"
      (handleTaskSelected)="(null)">
    </lib-header>
  }
  @if (!isFullPageRoute()) {
    <lib-subheader class="admin-subheader" [topMenu]="menu"></lib-subheader>
  }
  <div class="body">
    @if (!isFullPageRoute()) {
      <div class="breadcrumb-appcomponent-container">
        <lib-breadcrumbs></lib-breadcrumbs>
      </div>
    }
    @if (isRouteLoading()) {
      <div class="route-loading-container">
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    }
    <router-outlet (activate)="onRouteActivate()" (deactivate)="onRouteDeactivate()" />
  </div>
  <div class="footer">
    <lib-footer></lib-footer>
  </div>
  @if (sideDrawerService.config$ | async) {
    <lib-side-drawer></lib-side-drawer>
  }
</div>
